<template>
    <div class="container mb-10 md:mb-20">
        <NewsFilters
            v-if="categories"
            :categories="categories"
            :active-filter.sync="activeFilter"
        />
        <div class="w-full pb-20 sm:grid sm:grid-cols-2 md:grid-cols-3 sm:gap-x-8 lg:gap-x-12">
            <NewsCard
                v-for="(item, index) in entriesOnPage"
                :key="item.id"
                :item="item"
                :delay="index * 200 + 400"
            />
        </div>
        <button
            v-if="filteredItems.length > load"
            class="block mx-auto button button--pink"
            @click="load += paginate"
        >
            Load More
        </button>
    </div>
</template>

<script>
import axios from 'axios';
import NewsFilters from './NewsFilters.vue';
import NewsCard from './NewsCard.vue';

export default {
    components: {
        NewsFilters,
        NewsCard
    },

    data() {
        return {
            items: [],
            filteredItems: [],
            activeFilter: 'All',
            load: 6,
            paginate: 6
        };
    },

    computed: {
        categories() {
            const categories = this.items.reduce((total, curr) => {
                curr.categories
                    .filter((cat) => total.indexOf(cat) === -1)
                    .map((cat) => total.push(cat));
                return total.sort((a, b) => a.localeCompare(b));
            }, []);

            return ['All'].concat(categories);
        },

        entriesOnPage() {
            return this.filteredItems.slice(0, this.load);
        }
    },

    watch: {
        activeFilter() {
            this.getFilteredItems(this.activeFilter);
        }
    },

    async created() {
        const { data } = await axios.get('/api/news.json');
        this.items = data.data;
        this.filteredItems = data.data;

        this.getFilteredItems(this.activeFilter);
    },

    methods: {
        getFilteredItems(filter) {
            if (filter === 'All') {
                this.filteredItems = this.items;
            } else {
                const filteredItems = this.items.filter(
                    (item) => item.categories.indexOf(filter) >= 0
                );
                this.filteredItems = filteredItems;
            }
        }
    }
};
</script>
